import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body, H2} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Card} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button/Button"

interface Props {}

const WellbeingEAP: FC<Props> = () => {
  const theme = useTheme()

  return (
    <Card noBorder bgColor={theme.colors.greys.grey03}>
      <Flex direction="column" gap={2}>
        <H2>
          <FormattedMessage id="admin.reporting.wellbeing.title" />
        </H2>
        <Body maxWidth="100%">
          <FormattedMessage id="admin.reporting.wellbeing.body" />
        </Body>
        <Flex justifyContent="flex-start">
          <Button primary id="admin_EAP_reports_btn">
            <FormattedMessage id="admin.reporting.wellbeing.btn" />
          </Button>
        </Flex>
      </Flex>
    </Card>
  )
}

export default WellbeingEAP
